import { nanoid } from "nanoid";
import { song_col } from "../../../firebase";
export function db_format(word) {
	const regex = /[.,/#!$%^&{}*;:=\-_`~()?"]/g;
	return word
		.replace(regex, "")
		.toLowerCase()
		.trim();
}

export function add_nano_id(song_id) {
	const nano_id = nanoid(7);
	song_col
		.where("nano_id", "==", nano_id)
		.get()
		.then((docs) => {
			if (docs.empty) {
				console.log("empty");
				song_col.doc(song_id).update({ nano_id });
			} else add_nano_id(song_id);
		});
}
